import apiInstance from '../utils/axiosConfig';

const ContractEmployeService = {
    // Générer un PDF de contrat employé
    generateContractEmployePdf: async (id) => {
        try {
            const response = await apiInstance.get(`/contracts-employe/generateContractEmployePdf/${id}`, {
                responseType: 'arraybuffer'
            });
            return response.data;
        } catch (error) {
            console.error('Error generating contract employe PDF:', error);
            throw error;
        }
    },

    // Créer un contrat employé
    createContractEmploye: async (contractEmployeRequestDto) => {
        try {
            const response = await apiInstance.post('/contracts-employe/createContractEmploye', contractEmployeRequestDto);
            return response.data;
        } catch (error) {
            console.error('Error creating contract employe:', error.message || error);
            throw error;
        }
    },

    // ==================== SIGNATURES ====================

    // Signature par l'employé
    signByEmploye: async (id, username, signedPdfFile) => {
        try {
            const formData = new FormData();
            formData.append('username', username);
            formData.append('signedPdf', signedPdfFile);

            const response = await apiInstance.post(
                `/contracts-employe/sign-by-employe/${id}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error signing contract by employe:', error.message || error);
            throw error;
        }
    },

    // Signature par l'admin
    signByAdmin: async (id, username, signedPdfFile) => {
        try {
            const formData = new FormData();
            formData.append('username', username);
            formData.append('signedPdf', signedPdfFile);

            const response = await apiInstance.post(
                `/contracts-employe/sign-by-admin/${id}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error signing contract by admin:', error.message || error);
            throw error;
        }
    },

    // ==================== RÉCUPÉRATION ====================

    // Récupérer un contrat employé par ID
    getContractEmployeById: async (id) => {
        try {
            const response = await apiInstance.get(`/contracts-employe/getContractEmployeById/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching contract employe by id:', error.message || error);
            throw error;
        }
    },

    // Récupérer tous les contrats employés
    getAllContractEmployes: async () => {
        try {
            const response = await apiInstance.get('/contracts-employe/getAllContractEmployes');
            return response.data;
        } catch (error) {
            console.error('Error fetching all contract employes:', error.message || error);
            throw error;
        }
    },

    // Récupérer les contrats employés par ID de client
    getContractEmployesByClientId: async (clientId) => {
        try {
            const response = await apiInstance.get(`/contracts-employe/getContractEmployesByClientId/${clientId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching contract employes by client id:', error.message || error);
            throw error;
        }
    },

    // Récupérer les contrats employés par ID de professionnel
    getContractEmployesByProfessionalId: async (professionalId) => {
        try {
            const response = await apiInstance.get(`/contracts-employe/getContractEmployesByProfessionalId/${professionalId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching contract employes by professional id:', error.message || error);
            throw error;
        }
    },

    // Récupérer un contrat employé par ID d'EOI client
    getContractEmployeByClientEOIId: async (clientEOIId) => {
        try {
            const response = await apiInstance.get(`/contracts-employe/getContractEmployeByClientEOIId/${clientEOIId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching contract employe by client EOI id:', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un contrat employé
    updateContractEmploye: async (id, contractEmployeRequestDto) => {
        try {
            const response = await apiInstance.put(`/contracts-employe/updateContractEmploye/${id}`, contractEmployeRequestDto);
            return response.data;
        } catch (error) {
            console.error('Error updating contract employe:', error.message || error);
            throw error;
        }
    },

    // Supprimer un contrat employé
    deleteContractEmploye: async (id) => {
        try {
            await apiInstance.delete(`/contracts-employe/deleteContractEmploye/${id}`);
        } catch (error) {
            console.error('Error deleting contract employe:', error.message || error);
            throw error;
        }
    },
};

export default ContractEmployeService;